import React from 'react';
import PropTypes from 'prop-types';
import Prize from './styles';

const PrizeAsset = ({ prize, prizeImageUrl }) => {
    return (
        <Prize
            src={prizeImageUrl}
            alt={`One lucky winner will win... ${prize}!`}
        />
    );
};

PrizeAsset.propTypes = {
    prize: PropTypes.string,
    prizeImageUrl: PropTypes.string.isRequired
};

PrizeAsset.defaultProps = {
    prize: null
};

export default PrizeAsset;
